module.exports = __webpack_public_path__ + "img/member_card_4_1.41db122a.png";